
export const faqs = {
  hero: {
    title: 'Preguntas Frecuentes',
    subtitle: 'Todo lo que necesitas saber'
  },
  items: [
    {
      question: '¿Cuánto tiempo tarda la implementación completa?',
      answer: 'El tiempo de implementación varía según la complejidad de tu negocio. Un chatbot básico puede estar funcionando en 3-5 días. Una solución completa con web, agenda y recordatorios suele tomar entre 2 y 3 semanas. Te proporcionamos un cronograma detallado en la consulta inicial.'
    },
    {
      question: '¿Cómo se integra con mi sistema de gestión actual?',
      answer: 'Nos integramos con la mayoría de sistemas mediante APIs estándar. Trabajamos especialmente bien con Google Calendar, Calendly y sistemas de gestión populares. Si usas un software específico, lo evaluamos en la fase de análisis para garantizar compatibilidad total.'
    },
    {
      question: '¿El chatbot funciona en WhatsApp y redes sociales simultáneamente?',
      answer: 'Sí, nuestro chatbot funciona de forma unificada en WhatsApp Business, Instagram, Facebook Messenger y tu página web. Todas las conversaciones se centralizan en un único panel de control, permitiéndote gestionar todo desde un solo lugar.'
    },
    {
      question: '¿Cómo funcionan los recordatorios automáticos?',
      answer: 'El sistema envía recordatorios automáticos 24-48 horas antes de cada cita por WhatsApp, SMS o email (según tu configuración). El cliente puede confirmar, cancelar o reprogramar con un simple clic. Las cancelaciones liberan automáticamente el hueco en tu agenda.'
    },
    {
      question: '¿Qué tipo de soporte técnico ofrecen?',
      answer: 'Incluimos soporte técnico continuo por email y chat. Los planes Professional y Enterprise tienen soporte prioritario con tiempos de respuesta garantizados. También ofrecemos formación inicial para tu equipo y actualizaciones automáticas sin coste adicional.'
    },
    {
      question: '¿Es seguro? ¿Cumplen con la normativa de protección de datos?',
      answer: 'Absolutamente. Cumplimos con RGPD y LSSI. Todos los datos se almacenan en servidores europeos con cifrado de extremo a extremo. Firmamos acuerdos de confidencialidad y te proporcionamos toda la documentación necesaria para tu registro de actividades de tratamiento.'
    },
    {
      question: '¿Puedo hacer cambios después de la implementación?',
      answer: 'Sí, el sistema es completamente flexible. Puedes modificar respuestas del chatbot, ajustar horarios, añadir servicios o cambiar configuraciones en cualquier momento. Los cambios complejos que requieran desarrollo adicional se presupuestan por separado.'
    },
    {
      question: '¿Qué pasa si necesito pausar el servicio temporalmente?',
      answer: 'Entendemos que algunos negocios tienen temporadas bajas. Puedes pausar servicios específicos o reducir tu plan temporalmente. Contacta con tu gestor de cuenta para ajustar tu suscripción según tus necesidades actuales.'
    },
    {
      question: '¿Ofrecen formación para mi equipo?',
      answer: 'Sí, incluimos formación inicial completa para tu equipo (presencial u online). Además, proporcionamos manuales de usuario, vídeos tutoriales y sesiones de actualización cuando añadimos nuevas funcionalidades.'
    },
    {
      question: '¿Puedo ver métricas y estadísticas de rendimiento?',
      answer: 'Sí, todos los planes incluyen un panel de control con métricas en tiempo real: número de conversaciones, tasa de conversión, citas confirmadas, no-shows evitados, horarios de mayor demanda y mucho más. Los datos te ayudan a tomar decisiones informadas.'
    },
    {
      question: '¿Qué sucede con mis datos si cancelo el servicio?',
      answer: 'Tienes derecho a exportar todos tus datos en cualquier momento. Si cancelas, te proporcionamos una copia completa de tu información (conversaciones, historial de citas, datos de clientes) en formato estándar. Después eliminamos permanentemente tus datos de nuestros servidores.'
    },
    {
      question: '¿Necesito contratar todos los servicios o puedo elegir solo algunos?',
      answer: 'Puedes contratar servicios individuales o combinarlos según tus necesidades. Muchos clientes empiezan con el chatbot y van añadiendo funcionalidades progresivamente. Te asesoramos sobre la mejor estrategia para tu caso específico.'
    },
    {
      question: '¿Hay costes ocultos o cargos adicionales?',
      answer: 'No. El precio acordado incluye todo lo especificado en tu propuesta: implementación, formación, soporte y mantenimiento. Los únicos costes adicionales serían desarrollos personalizados fuera del alcance inicial, siempre presupuestados y aprobados previamente.'
    },
    {
      question: '¿Qué diferencia hay entre el chatbot y un sistema de respuestas automáticas básico?',
      answer: 'Nuestro chatbot usa inteligencia artificial para entender el contexto y mantener conversaciones naturales. No solo responde preguntas predefinidas, sino que aprende de cada interacción, gestiona reservas complejas y deriva a humanos cuando es necesario. Es mucho más sofisticado que un simple autoresponder.'
    },
    {
      question: '¿Puedo probar el sistema antes de comprometerme?',
      answer: 'Ofrecemos una consulta gratuita donde te mostramos demos personalizadas y casos de éxito similares a tu negocio. Algunos planes permiten periodo de prueba inicial. Contacta con nosotros para explorar opciones según tu situación.'
    }
  ],
  ctaFinal: {
    title: '¿No encuentras tu respuesta?',
    description: 'Contacta con nosotros y resolveremos todas tus dudas'
  }
};
